import { useEffect, useState } from "react";
import QrScanner from "qr-scanner";
import { ReactComponent as ExclamationIcon } from "../../assets/icons/exсlamation-icon.svg";
import { ReactComponent as QrSquare } from "../../assets/images/qr-square.svg";
import { observer } from "mobx-react";
import {
  decodeText,
  encodeString,
  importPrivateKeyPem,
  importPublicKeyPem,
  str2ab,
  stringifyBuffer,
} from "../../helpers/crypto";
import { createSupervision, getTestResult } from "../../api/testResult";
import { BackButton } from "../../components/BackButton";
import testResultStore from "../../stores/TestResultStore";
import "./Scanner.scss";
import { getPrivateKeyPem } from "../../utils/localStorage";
import supervisorStore from "../../stores/SupervisorStore";
import { useHistory } from "react-router-dom";
import { TEST_RESULT_PREVIEW } from "../../constants/routes";
import { useAlert } from "react-alert";
import {
  ERROR_SIGNATURE_VERIFICATION_FAILED,
  HOLD_PHONE_STEADY,
  MOVE_QR_IN_FRAME,
  VALIDATION_NOT_A_PASS_ME_CODE,
  VALIDATION_SCAN_ON_TEST_CARTRIGE,
} from "src/constants/translationKeys";
import translationsStore from "../../stores/TranslationsStore";
QrScanner.WORKER_PATH = "qr-scanner/qr-scanner-worker.min.js";

const Scanner = observer(() => {
  const [scannedStatus, setScannedStatus] = useState("UNUSED");
  const [selectedCamera, setSelectedCamera] = useState('undefined');
  const [cameras, setCameras] = useState([]);
  const [scanner, setScanner] = useState<any>(null);



  const history = useHistory();
  const alert = useAlert();
  const setVh = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  };
  const translations = translationsStore.translations;
  useEffect(() => {
    testResultStore.alert = alert;
    if (testResultStore.codeNew) {
      alert.show("Test was never used before", { type: "error" });
      testResultStore.codeNew = false;
      setTimeout(() => {
        testResultStore.scanInProgress = false;
      }, 5000)
    }
    // eslint-disable-next-line
  }, [alert, testResultStore.codeNew]);

  window.addEventListener("load", setVh);
  window.addEventListener("resize", setVh);

  useEffect(() => {
    const handleTestkitScan = (data: string) => {
      const splitted = data.split("/");
      testResultStore.loadTestResult(splitted[1]);
    };

    const handleScan = (scanData: string | null) => {
      console.log(scanData);
      if (testResultStore.scanInProgress || !scanData) return;
      
      testResultStore.scanInProgress = true;

      if (supervisorStore.testkit) {
        // window.alert(1);
        handleTestkitScan(scanData);
        return;
      } else {

        // window.alert(2);
        const splitted = scanData.split(";");
        const dataString = splitted[1];
        try {
          const signedQrDataString = atob(splitted[2]);
          const decodedDataString = atob(dataString);
          const decodedQrData: {
            birthday: string;
            first: string;
            last: string;
            identifier: string;
            result: string;
          } = JSON.parse(decodedDataString);
          getTestResult(decodedQrData.result)
            .then(async (testResult) => {
              const endpointPublicKey = testResult.testee.publicKey;
              const qrIdentifier = decodedQrData.identifier;
              const endpointIdentifier = testResult.testee.randomIdentifier;
              if (qrIdentifier === endpointIdentifier) {
                const publicKeyPem = await importPublicKeyPem(
                  endpointPublicKey
                );
                const verified = await crypto.subtle.verify(
                  "RSASSA-PKCS1-v1_5",
                  publicKeyPem,
                  str2ab(signedQrDataString),
                  str2ab(decodedDataString)
                );
                if (verified) {
                  testResultStore.setTestResult(testResult);
                  testResultStore.setTesteeFullName(
                    decodeText(`${decodedQrData.first} ${decodedQrData.last}`)
                  );
                  signAndCreateSupervision(testResult.id).then(() => {
                    history.push(TEST_RESULT_PREVIEW);
                    testResultStore.scanInProgress = false;
                  });
                } else {
                  setScannedStatus("VERIFICATION_FAILED");
                  testResultStore.scanInProgress = false;
                }
              } else {
                setScannedStatus("VERIFICATION_FAILED");
                testResultStore.scanInProgress = false;
              }
            })
            .catch((error) => {
              console.log({ error });
              setScannedStatus("INVALID");
              testResultStore.scanInProgress = false;
            });
        } catch (error) {
          setScannedStatus("INVALID");
          testResultStore.scanInProgress = false;
        }
      }
    };

    let qrScanner: any = new QrScanner(
      document.getElementById("scanner") as any,
      handleScan
    );
    setScanner(qrScanner);
    if (qrScanner) {
      qrScanner.start();
      QrScanner.listCameras(true).then((cams: any) => {
        if (cams.length > 0) {
          setCameras(cams);
          setSelectedCamera(cams[0].id);
        }
      });
    }

    return () => {
      qrScanner.destroy();
      qrScanner = null;
    };
  }, [history]);

  const setCamera = (e: any) => {
    if (scanner) {
      scanner.setCamera(e.target.value);
      setSelectedCamera(e.target.value);
    }
  };

  const signAndCreateSupervision = async (testResultId: string) => {
    const supervisorId = supervisorStore.supervisor?.id;
    const supervision: {
      supervisor_id: string;
      result_id: string;
      signed: string;
    } = {
      supervisor_id: supervisorId!,
      result_id: testResultId,
      signed: "",
    };

    const privateKeyPem = getPrivateKeyPem()!;
    try {
      const privateKey = await importPrivateKeyPem(privateKeyPem);
      var signed = await crypto.subtle.sign(
        "RSASSA-PKCS1-v1_5",
        privateKey,
        encodeString(`${supervisorId};${testResultId};`)
      );
      supervision["signed"] = stringifyBuffer(signed);
      return createSupervision(supervision)
        .then((response) => {
          const supervisionId = response.data.id;
          testResultStore.setSupervisionId(supervisionId);
          return Promise.resolve();
        })
        .catch((error) => {
          setScannedStatus("VERIFICATION_FAILED");
          // setScanInProgress(false);
        });
    } catch (e) {
      console.log({ e });
    }
  };

  const ScannerMessage = (props: any) => {
    switch (props.status) {
      case "USED":
      case "FAILED":
        return (
          <>
            <ExclamationIcon />
            <div className="qr-message__title">
              QR code previously used already
            </div>
            <p>Scann the QR-Code on the Test Cartridge</p>
          </>
        );
      case "VERIFICATION_FAILED":
        return (
          <>
            <ExclamationIcon />
            <div className="qr-message__title">
              {translations[ERROR_SIGNATURE_VERIFICATION_FAILED] ||
                "Signature verification failed."}
            </div>
          </>
        );
      case "INVALID":
        return (
          <>
            <ExclamationIcon />
            <div className="qr-message__title">
              {translations[VALIDATION_NOT_A_PASS_ME_CODE] ||
                "Not a pass.me QR-Code?"}
            </div>
            <p>
              {translations[VALIDATION_SCAN_ON_TEST_CARTRIGE] ||
                "Scann the QR-Code on the Test Cartridge"}
            </p>
          </>
        );
      default:
        return (
          <div className="qr-message__title">
            {translations[MOVE_QR_IN_FRAME] || "Move the QR-Code in the frame."}
            <br />
            {translations[HOLD_PHONE_STEADY] || "Hold the Phone steady"}
          </div>
        );
    }
  };

  return (
    <div className="scanner-page content">
      <div className="container">
        <BackButton />
        <div className={`qr-message qr-message--${scannedStatus}`}>
          <ScannerMessage status={scannedStatus} />
        </div>
        <div className="qr-box">
            <QrSquare />
            <video id="scanner"></video>
            <div className="whiteOverlay"></div>
        </div>
        {cameras.length > 0 && selectedCamera && (
            <select name="camera" value={selectedCamera}  onChange={setCamera}>
              {cameras.map((cam: any) => (
                <option key={cam.id} value={cam.id}>
                  {cam.label}
                </option>
              ))}
            </select>
          )}
      </div>
    </div>
  );
});

export default Scanner;
